import React from 'react'
import PropTypes from 'prop-types'

const FourOhFour = ({location}) => (
	<div className="alert alert-danger" role="alert">
		{`404. "${location.pathname}" Not Found`}
	</div>
)

FourOhFour.propTypes = {
	location: PropTypes.shape({
		pathname: PropTypes.string
	})
}

export default FourOhFour



// WEBPACK FOOTER //
// ./client/components/FourOhFour/index.js